import React from 'react';
import { Box, CircularProgress, SxProps, Typography, useTheme } from '@mui/material';
import { InformationChip } from '@europrocurement/flexy-components';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

export type PriorityChipDossierProps = {
    critical?: boolean;
    fontSx?: SxProps;
    /**
     * Si true, affiche une flèche pour indiquer que le chip est interactif
     */
    showDropdownIndicator?: boolean;
    /**
     * État de survol pour l'effet d'animation
     */
    isHovered?: boolean;
    isLoading?: boolean;
};

const PriorityChipDossier: React.FunctionComponent<PriorityChipDossierProps> = function ({
    critical = false,
    fontSx,
    showDropdownIndicator = false,
    isHovered = false,
    isLoading = false,
}) {
    const { palette } = useTheme();
    const label = critical ? 'Urgent' : 'Normal';
    const color = critical ? 'error' : 'primary';
    const baseColor = palette[color].main;

    const chipContent = (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
            }}
        >
            {isLoading ? (
                <Box
                    sx={{
                        width: '60px',
                        height: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CircularProgress size={18} />
                </Box>
            ) : (
                <Typography
                    variant="l2dbodys"
                    color={baseColor}
                    sx={{
                        ...fontSx,
                        transform: isHovered ? 'scale(1.05)' : 'scale(1)',
                        transition: 'transform 0.2s ease-in-out',
                    }}
                >
                    {label}
                </Typography>
            )}

            {/* Flèche indicative seulement si demandée */}
            {showDropdownIndicator && (
                <FaOptionIcon
                    icon={['fasl', 'chevron-down']}
                    size="xs"
                    sx={{
                        fontSize: '8px',
                        color: baseColor,
                        opacity: isHovered ? 1 : 0.7,
                        transition: 'opacity 0.2s ease-in-out',
                    }}
                />
            )}
        </Box>
    );

    return (
        <InformationChip
            color={color}
            label={chipContent}
        />
    );
};

export default PriorityChipDossier;
